import OnDemandReportCreation from "../../../../src/pages/use-cases/page-content/content-publishing/on-demand-report-creation.md";
import * as React from 'react';
export default {
  OnDemandReportCreation,
  React
};